import React from "react";
import PropTypes from "prop-types";

import {
  ALIGNMENT_OPERATIONS,
  DISTRIBUTION_OPERATIONS,
} from "../../../engines/StudioAlignmentEngine";


const ALIGNMENT_ACTIONS = Object.freeze([
  {
    operation: ALIGNMENT_OPERATIONS.LEFT,
    label: "Aligner à gauche",
    symbol: "⇤",
  },
  {
    operation: ALIGNMENT_OPERATIONS.CENTER_X,
    label: "Centrer horizontalement",
    symbol: "↔",
  },
  {
    operation: ALIGNMENT_OPERATIONS.RIGHT,
    label: "Aligner à droite",
    symbol: "⇥",
  },
  {
    operation: ALIGNMENT_OPERATIONS.TOP,
    label: "Aligner en haut",
    symbol: "↥",
  },
  {
    operation: ALIGNMENT_OPERATIONS.CENTER_Y,
    label: "Centrer verticalement",
    symbol: "↕",
  },
  {
    operation: ALIGNMENT_OPERATIONS.BOTTOM,
    label: "Aligner en bas",
    symbol: "↧",
  },
]);


const DISTRIBUTION_ACTIONS = Object.freeze([
  {
    operation:
      DISTRIBUTION_OPERATIONS.HORIZONTAL_CENTERS,
    label: "Distribuer les centres horizontalement",
    symbol: "⋯",
  },
  {
    operation:
      DISTRIBUTION_OPERATIONS.VERTICAL_CENTERS,
    label: "Distribuer les centres verticalement",
    symbol: "⋮",
  },
  {
    operation:
      DISTRIBUTION_OPERATIONS.HORIZONTAL_GAPS,
    label: "Égaliser les espaces horizontaux",
    symbol: "↔︎",
  },
  {
    operation:
      DISTRIBUTION_OPERATIONS.VERTICAL_GAPS,
    label: "Égaliser les espaces verticaux",
    symbol: "↕︎",
  },
]);


export default function AlignmentToolbar({
  selectionCount = 0,
  onAlign,
  onDistribute,
  className = "",
}) {
  const alignmentDisabled = selectionCount < 2;
  const distributionDisabled = selectionCount < 3;

  return (
    <div
      className={[
        "studio-alignment-toolbar",
        className,
      ].filter(Boolean).join(" ")}
      role="toolbar"
      aria-label="Alignement et distribution"
    >
      <div className="studio-alignment-toolbar__group">
        {ALIGNMENT_ACTIONS.map((action) => (
          <button
            key={action.operation}
            type="button"
            className="studio-alignment-toolbar__button"
            aria-label={action.label}
            title={action.label}
            disabled={alignmentDisabled}
            onClick={() => onAlign(
              action.operation,
            )}
          >
            {action.symbol}
          </button>
        ))}
      </div>

      <div className="studio-alignment-toolbar__separator" />

      <div className="studio-alignment-toolbar__group">
        {DISTRIBUTION_ACTIONS.map((action) => (
          <button
            key={action.operation}
            type="button"
            className="studio-alignment-toolbar__button"
            aria-label={action.label}
            title={action.label}
            disabled={distributionDisabled}
            onClick={() => onDistribute(
              action.operation,
            )}
          >
            {action.symbol}
          </button>
        ))}
      </div>
    </div>
  );
}


AlignmentToolbar.propTypes = {
  selectionCount: PropTypes.number,
  onAlign: PropTypes.func.isRequired,
  onDistribute: PropTypes.func.isRequired,
  className: PropTypes.string,
};
